"use strict";
/* ENUMS */
Object.defineProperty(exports, "__esModule", { value: true });
var ListenerResult;
(function (ListenerResult) {
    ListenerResult[ListenerResult["HANDLED"] = 0] = "HANDLED";
    ListenerResult[ListenerResult["UNHANDLED"] = 1] = "UNHANDLED";
    ListenerResult[ListenerResult["UNHANDLEABLE"] = 2] = "UNHANDLEABLE"; // No handler caught that, and there are no deeper handlers that could catch that
})(ListenerResult || (ListenerResult = {}));
exports.ListenerResult = ListenerResult;
;
